import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from '../moov-common/base/base.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Locale } from '../moov-common/enum/locale.enum';
import { NAVIGATION_ROUTES } from '../navigation-routes.const';
import { AbstractPersonalUserDataService } from '../moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.scss',
})
export class UnsubscribeComponent extends BaseComponent implements OnDestroy {
  isLoading = false;
  isSuccess = false;
  isErr = false;
  err: any = null;
  urlParams = {
    mailAddress: '',
    unsubscribeType: '',
    locale: '',
  };
  unsubscribeFromType: UnsubscribeFromTypeEnum;
  unsubscribeTypeInstance = UnsubscribeFromTypeEnum;
  private routeSubscription: Subscription; // Store the subscription

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userDataService: AbstractPersonalUserDataService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.routeSubscription = this.route.queryParams.subscribe(
      (params: Params) => {
        this.shouldNavigateToPersonalView(params);
        this.initUrlParamsAndUnsubscribeFromType(params);
        this.setLocale(this.urlParams);
      }
    );
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  private shouldNavigateToPersonalView(params: Params) {
    if (
      !params.mailAddress ||
      params.mailAddress === '' ||
      !params.unsubscribeType ||
      params.unsubscribeType === ''
    ) {
      // if no email or unsubscribeType in url, navigate to personal view
      this.router.navigate([NAVIGATION_ROUTES.app.personalView]);
    }
  }

  private setLocale(params: Params) {
    let { locale } = params;
    if (locale == undefined || locale === '') {
      console.log(`US setLocale locale is empty `);
      locale = 'en-US';
    }
    this.userDataService.setLocale(locale);
  }

  private initUrlParamsAndUnsubscribeFromType(params: Params) {
    this.unsubscribeFromType = parseInt(params.unsubscribeType);
    Object.assign(this.urlParams, params);
  }

  unsubscribe() {
    const { mailAddress: userEmail, unsubscribeType } = this.urlParams;
    this.isLoading = true;
    this.userDataService.unsubscribeMail(userEmail, unsubscribeType).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.isSuccess = true;
        this.analytics.userUnsubscribedEvent(parseInt(unsubscribeType));
      },
      error: (err) => {
        this.isLoading = false;
        this.isErr = true;
        this.err = err;
        console.log('unsubscribe error', err);
      },
    });
  }
}

enum UnsubscribeFromTypeEnum {
  Insights = 1,
  Questions = 2,
}
